// Design Tokens

// Colors
export const colors = {
  // Primary
  primary: '#1976d2',
  primaryLight: '#42a5f5',
  primaryDark: '#1565c0',

  // Secondary
  secondary: '#388e3c',
  secondaryLight: '#66bb6a',
  secondaryDark: '#2e7d32',

  // Status
  success: '#4caf50',
  warning: '#ff9800',
  error: '#f44336',
  errorLight: '#ffebee',
  info: '#2196f3',

  // Neutral
  white: '#ffffff',
  black: '#000000',
  gray50: '#fafafa',
  gray100: '#f5f5f5',
  gray200: '#eeeeee',
  gray300: '#e0e0e0',
  gray400: '#bdbdbd',
  gray500: '#9e9e9e',
  gray600: '#757575',
  gray700: '#616161',
  gray800: '#424242',
  gray900: '#212121',

  // Semantic
  text: '#212121',
  textSecondary: '#757575',
  textDisabled: '#bdbdbd',
  border: '#e0e0e0',
  background: '#fafafa',
  backgroundAlt: '#ffffff',
  surface: '#ffffff',
};

// Spacing (px)
export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  '2xl': '48px',
  '3xl': '64px',
};

// Typography
export const typography = {
  h1: {
    fontSize: '32px',
    fontWeight: '600',
    lineHeight: '1.2',
    letterSpacing: '-0.01em',
  },
  h2: {
    fontSize: '28px',
    fontWeight: '600',
    lineHeight: '1.3',
    letterSpacing: '-0.005em',
  },
  h3: {
    fontSize: '24px',
    fontWeight: '600',
    lineHeight: '1.4',
  },
  h4: {
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '1.4',
  },
  body: {
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '1.6',
  },
  small: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '1.5',
  },
  caption: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '1.4',
  },
};

// Shadows
export const shadows = {
  none: 'none',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
};

// Border Radius
export const borderRadius = {
  none: '0',
  xs: '2px',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '9999px',
};

// Transitions
export const transitions = {
  fast: '150ms ease-in-out',
  base: '200ms ease-in-out',
  slow: '300ms ease-in-out',
};
// Typography flat access (for inline styles)
export const typographyFlat = {
  fontSize: {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '20px',
    xl: '24px',
    xxl: '28px',
    xxxl: '32px',
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};

// Color helpers for dark variants (not in tokens but commonly needed)
export const colorExtensions = {
  successDark: '#388e3c',
  errorDark: '#d32f2f',
  warningDark: '#f57c00',
  infoDark: '#1976d2',
};